import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { MenuService } from '../../../../services/menu.service';
import { ConfigService } from '../../../../services/config.service';
import { LogService } from '../../../../services/log.service';
import { DataIoService } from '../../../../services/data-io.service';
import { TranslationService } from '../../../../services/translation.service';
import { LoadinganimationComponent } from '../loadinganimation/loadinganimation.component';
import { Helper, MenuNode, BaseSensor, ISensorInterface } from '../../../../classes';
import { ValueChangedConfirmation } from '../../../../classes/ValueChangedConfirmation';
import { TextinputComponent } from '../../../helpers/textinput/textinput.component';

@Component({
    selector: 'screen-settingsvalue',
    templateUrl: './settingsvalue.component.html',
    styleUrls: ['./settingsvalue.component.scss']
})

export class SettingsvalueComponent implements OnInit {


    @Input('debug') debug: false;
    enabled_buttons: Array<string>;

    title: string = "";
    subTitle: string = "";
    unit: string = "STD_UNIT_CELSIUS_NORMAL_LEFT";
    min: number;
    max: number;
    circular: boolean = false;
    menuIcon: string = "";
    currentNode: MenuNode = null;
    _value: any;
    _sensor: BaseSensor;
    get value(): any {
        return this._value;
    }

    set value(v: any) {
        this._value = v;
    }


    steps: number = 0.1;
    dashIcon: string = "";
    buttonSubscription$: any;
    showMarker = false;
    showTexts = false;
    showTextInput = false;
    darkTitle = false;
    brightText = false;
    brightText1 = false;
    brightText2 = false;
    brightText3 = false;
    numberStyle = "int";
    type: string;
    pans = 0;
    panSkip = 4;
    _valueLeft = 0;
    valueLeft = "0%"
    constructor(
        private menuService: MenuService,
        private ioService: DataIoService,
        private logger: LogService,
        private config: ConfigService,
        private translator: TranslationService) {
        this.currentNode = menuService.getCurrentNode();
    }

    isBlinking: boolean;
    // blinkende werte (code falsch eingegeben)
    blinkValue() {
        this.isBlinking = true;
        setTimeout(() => {
            this.isBlinking = false;
        }, 1000);
    }

    changed = false;
    // blinkende buttons (z.B. nach veränderung)
    blink() {
        if (!this.changed) {
            this.changed = true;
            this.menuService.blinkButton('confirm');
        }
    }
    temperatureForTimeFrameEventHandler(event) {
        if (event != "confirm") {
            this.menuService.resetTimeout();
        }
        switch (event) {
            case 'panup': {
                this.blink();
                this.pans = (++this.pans % this.panSkip);
                if (this.pans != 0) {
                    return;
                }

            }
            case 'up': {
                this.blink();
                this.temperatureEventHandler('up');
                return;
            }
            case 'pandown': {
                this.blink();
                this.pans = (++this.pans % this.panSkip);
                if (this.pans != 0) {
                    return;
                }
            }
            case 'down': {
                this.blink();
                this.temperatureEventHandler('down');
                return;
            }

            case 'confirm': {

                let timeframe = this.ioService.getCurrentTimeFrame();
                this.ioService.currentTimeFrame.setValue(this.value);
                let zone = this.currentNode.get('zone');
                let day = this.currentNode.get('day');
                let table = this.currentNode.get('table');
                if (table == 'heating') {
                    timeframe.setIgnoreTemperature(false);
                }
                let mode = this.currentNode.get('mode');
                if (mode == "add") {
                    this.ioService.deviceInfo().getZoneById(parseInt(zone)).getTimeFrameManager(table).addTimeFrame(timeframe);
                }
                if (mode == "edit") {
                    let id = this.currentNode.get('id');

                    let tfm = this.ioService.deviceInfo().getZoneById(parseInt(zone)).getTimeFrameManager(table);
                    if (tfm) {
                        tfm.patch(parseFloat(id), timeframe);
                    } else {
                        this.logger.debug("TimeFrame-Manager is null.");
                    }
                }
                let cnfmtn = new ValueChangedConfirmation('timeframe', '0', '1', this.currentNode);
                if (this.currentNode.hasTarget()) {
                    let target = this.currentNode.getTargetNode();
                    if (target) {
                        if (!this.currentNode.hasParameter('')) {
                            this.menuService.goto(target, cnfmtn);
                        } else {
                            this.menuService.goto(target, undefined);
                        }
                        return;
                    }
                }

                if (!this.menuService.historyBack(cnfmtn)) {
                    this.menuService.hierarchyUp(false, cnfmtn);
                    return;
                } else {
                    return;
                }
            }
            case 'back': {
                this.backClicked();
                return;
            }
            case 'question': {
                this.menuService.showHelp();
                return;
            }
        }
    }
    backClicked() {

        this.logger.debug("Back clicked.");
        if (this.currentNode.hasBackTarget()) {
            this.logger.debug("Goto backtarget ");
            let backTarget = this.currentNode.getBackTargetNode()
            if (backTarget) {
                this.logger.debug("Backtarget is: " + backTarget.getTitle());
            } else {
                console.error("Backtarget not found on " + this.currentNode.getIdentifier());
            }
            this.menuService.goto(backTarget);
            return;
        }

        if (this.currentNode.getType() == "code") {
            this.logger.debug("Goto hierarchy up");
            this.menuService.hierarchyUp();
            return;
        }
        this.logger.debug("Goto history back");
        if (!this.menuService.historyBack()) {
            this.logger.debug("failed. going hierarchy up");
            this.menuService.hierarchyUp();
            return;
        }
    }

    temperatureEventHandler(event) {
        //this.panSkip=1;
        if (event != "confirm") {
            this.menuService.resetTimeout();
        }

        switch (event) {

            case 'question': {
                this.menuService.showHelp();
                return;
            }

            case 'panup': {
                this.blink();

                this.pans = (++this.pans % this.panSkip);
                if (this.pans != 0) {

                    return;
                }
            }

            case 'up': {
                this.blink();
                let steps = this.steps;

                console.log("Up clicked, value was " + this.value + ", adding " + this.steps);
                this.value = parseFloat("" + this.value);
                this.value += this.steps;
                this.value = Math.round(100 * this.value) / 100;
                console.log({ circular: this.circular });
                if (!this.circular && this.value > this.max) {
                    console.log("max-value reached (" + this.max + ")");
                    this.value = this.max;
                } else if (this.circular && this.value > this.max) {
                    console.log("max-value reached (" + this.max + ")");
                    this.value = this.min;
                }
                if (this.currentNode.hasParameter('immediate')) {
                    this.menuService.currentNode.onConfirm(this.value);
                }
                if (this._sensor && this._sensor.hasSpecialValue(this.value)) {
                    let sv = this._sensor.getSpecialValue(this.value);
                    if (this.hasParameter('showSpecialValueIcons') && sv.hasIcon()) {
                        this._valueIsIcon = true;
                    } else {
                        this._valueIsIcon = false;
                    }
                } else {
                    this._valueIsIcon = false;
                }
                /** hidden values currently only works for circular elements */
                if (this._sensor.isList()) {
                    if (this.hiddenValues().includes(this._sensor.getValueAt(this.value))) {
                        if (this.circular) {
                            return this.temperatureEventHandler('up');
                        }
                    }
                }
                return;
            }

            case 'pandown': {
                this.blink();

                this.pans = (++this.pans % this.panSkip);
                if (this.pans != 0) {

                    return;
                }
            }

            case 'down': {
                this.blink();
                this.value -= this.steps;
                this.value = Math.round(100 * this.value) / 100;
                if (!this.circular && this.value < this.min) {
                    this.value = this.min;
                } else if (this.circular && this.value < this.min) {
                    this.value = this.max;
                }
                if (this.currentNode.hasParameter('immediate')) {
                    this.menuService.currentNode.onConfirm(this.value);
                }

                if (this._sensor && this._sensor.hasSpecialValue(this.value)) {
                    let sv = this._sensor.getSpecialValue(this.value);
                    if (this.hasParameter('showSpecialValueIcons') && sv.hasIcon()) {
                        this._valueIsIcon = true;
                    } else {
                        this._valueIsIcon = false;
                    }
                } else {
                    this._valueIsIcon = false;
                }
                if (this._sensor.isList()) {
                    if (this.hiddenValues().includes(this._sensor.getValueAt(this.value))) {
                        if (this.circular) {
                            return this.temperatureEventHandler('down');
                        }
                    }
                }
                return;
            }

            case 'confirm': {
                if (this.currentNode.getType() == "code") {
                    this.ioService.deviceInfo().getScale('last_code').setCurrentValue(this.getValue());

                    if (!([17, 19].includes(parseInt(this.getValue())))) {
                        this.logger.debug("this.getValue:" + this.getValue() + " does not match " + this.ioService.deviceInfo().getScaleValue('code'));
                        this.blinkValue();
                        return;
                    } else {
                        this.ioService.startCodeReset();
                    }

                }

                //console.log("Confirm.");

                let confirmation = this.menuService.currentNode.onConfirm(this.value);
                if (this.menuService.getCurrentNode().hasConditionalTargets()) {
                    console.log("Current node has conditional targets.");
                    let conditionalTarget = this.menuService.getCurrentNode().getConditionalTargetNode();
                    console.log("found conditional target:" + conditionalTarget);
                    this.menuService.goto(conditionalTarget, confirmation);
                    return;
                }
                if (this.menuService.currentNode.hasTarget()) {
                    //console.log("has target.");
                    let target = this.menuService.currentNode.getTargetNode();

                    if (target) {
                        //console.log("going to "+target.getIdentifier());
                        this.menuService.goto(target, confirmation);
                        return;
                    } else {
                        //console.log("target empty: "+this.menuService.currentNode.getTarget());
                    }
                }
                return;
            }
            case 'back': {
                if (this.currentNode.getType() == "code") {
                    this.ioService.startCodeReset();
                }
                this.backClicked();
                return;
            }
        }
    }


    hasParameter(p: string): boolean {
        return this.currentNode.hasParameter(p);
    }
    currentChar: any;
    currentCharChanged(char) {
        this.logger.debug("Current char changed to " + char);
        if (char === undefined) {
            return;
        }
        if (char == "") {
            this.currentChar = false;
        } else {
            this.currentChar = char;
        }
    }

    saveText(text) {
        if (text != undefined && text != null) {
            let confirmation = this.menuService.currentNode.onConfirm(text);
            if (this.currentNode.hasTarget()) {
                let target = this.currentNode.getTargetNode();
                if (target) {
                    this.menuService.goto(target, confirmation);
                    return;
                }
            }

            this.menuService.hierarchyUp(confirmation);
        } else {
            this.logger.debug("Text is undefined in onSave-Listener.");
        }
    }

    textChanged(text) {
        if (text == undefined) {
            this.logger.debug("text changed to undefined.");
            return;
        }
        this.value = text;
        this.updateValueLeft();
    }

    // abstand nach links..
    updateValueLeft() {
        if (this.value.length > 9) {
            this._valueLeft = (this.value.length - 9);

        } else {
            this._valueLeft = 0;
        }
        this.valueLeft = (-0.75 * this._valueLeft) + "em";
    }
    stringEventHandler(event) {
        if (event != "confirm") {
            this.menuService.resetTimeout();
        }
        // textinput kümmert sich um den rest.
        switch (event) {
            case 'back': {
                this.logger.debug("Going back in history.");
                this.menuService.historyBack();
                return;
            }
            case 'question': {
                this.menuService.showHelp();
                return;
            }
        }
    }
    get lightTitle() {
        return this.hasParameter('lightTitle');
    }
    get lightSubtitle() {
        return this.hasParameter('lightSubtitle');
    }

    countdownIteration() {
        this.value -= 1;
        if (this.value > 0) {
            this.startCountdown();
        } else {

            this.currentNode.onConfirm(undefined);
            //console.log("Locked: "+this.ioService.getDeviceInfo().getValue('buttonlock'));
            this.menuService.goto(this.currentNode.getTargetNode().getIdentifier());
        }
    }
    private countDown = null;
    private countdownRunning = false;
    startCountdown() {
        this.countdownRunning = true;
        this.countDown = setTimeout(() => {
            this.countdownIteration();
        }, 1000);

    }
    delayHandle: any = undefined;
    delayed: boolean = false;

    startDelayTimer() {
        if (this.delayHandle) {
            clearTimeout(this.delayHandle);
        }
        this.delayHandle = setTimeout(
            () => {
                this.delayed = false;
                this.delayHandle = undefined;
            }, 500);
    }


    ngOnInit() {
        //console.log("Init." + this.menuService.currentNode.getType());

        if (this.currentNode.hasParameter('zeitprogrammassistent')) {
            this.darkTitle = true;
            this.brightText = true;
        }
        if (this.currentNode.hasParameter('loadDelay')) {
            this.delayed = true;
            this.startDelayTimer();
        }
        if (this.currentNode.hasParameter('brightText')) {
            this.brightText = true;
        }
        if (this.currentNode.hasParameter('brightText1')) {
            this.brightText1 = true;
        }
        if (this.currentNode.hasParameter('brightText2')) {
            this.brightText2 = true;
        }
        if (this.currentNode.hasParameter('brightText3')) {
            this.brightText3 = true;
        }
        this.type = this.menuService.currentNode.getType();
        this.menuService.onElementFocused(this.currentNode);
        switch (this.type) {
            case 'countdown': {
                this.unit = '';
                this.title = this.currentNode.getTitle();
                this.value = this.currentNode.getValue();
                this.startCountdown();
                return;
            }
            case 'temperature': {
                this.configureTemperatureSetter();
                return;
            }
            case 'numberstring': {

            }
            case 'string': {
                this.configureStringSetter();
                return;
            }
            case 'timeframe-temperature': {
                this.timeframeTemperatureSetter();
                return;
            }
            case 'changecode': {

            }
            case 'code': {
                let code_id = 'last_code';
                this.ioService.stopCodeReset();
                let scale = this.ioService.deviceInfo().getScale(code_id);
                if (!scale) {
                    scale = BaseSensor.fromArgs(code_id, 0, 0, 99, 1, "");
                    this.ioService.deviceInfo().setScale(code_id, scale);
                }


                this.currentNode.setValue(scale.getCurrentValue());

            }
            case 'number': {
                this.defaultSetup();
                this.circular = this.hasParameter('circular');
                this.value = (this.currentNode.getValue());
                this.unit = "";
                this.numberStyle = "twodigit";
                this.steps = 1;
                this.min = 0;
                this.max = 99;
                if (this.value == 0) {
                    this.value = "00";
                }
                break;
            }
            default: {
                this.defaultSetup();
                this.circular = this.hasParameter('circular');
                if (!this.value) {
                    this.value = 0;
                    this.unit = "";

                }
            }
        }

    }
    hiddenValues(): string[] {
        console.log({ params: this.currentNode.template_parameter });
        let hidden = this.currentNode.template_parameter
            .split(',')
            .map(
                (x: string) => (x.trim())
            ).filter(
                (x: string) => x.startsWith('hide')
            );
        if (hidden.length > 0) {
            hidden = hidden.map((x: string) => x.replace('hide:', ''));
            let translated = hidden.map((x: string) => this.translator.tr(x));
            hidden.push(...translated);
            console.log({ hidden: hidden });
            return hidden;
        } else {
            console.log("nothing is hidden.");
            return [];
        }
    }
    defaultSetup() {
        //this.panSkip = 5;
        this.title = this.menuService.currentNode.getTitle();
        this.subTitle = this.currentNode.getSubTitle();
        this.buttonSubscription$ = this.ioService.inputs.events$.subscribe(
            (event) => { this.temperatureEventHandler(event); }
        );
        this.showMarker = true;
        this.showTexts = true;


        this.showTextInput = false;
        let sensor = this.menuService.currentNode.getOnConfirmTarget();





        if (sensor instanceof BaseSensor) {
            this.unit = sensor.getUnit();
            this.steps = sensor.getGranularity();
            this.min = sensor.getMinValue();
            this.max = sensor.getMaxValue();
            this.value = (sensor.getCurrentValue());
            this._sensor = sensor;
            if (this.steps <= 0.1) {
                this.numberStyle = "twodecimals";
            }
            //console.log("Setup with sensor "+sensor.toString());
        } else {
            //console.log("Sensor not found for element "+this.currentNode.getIdentifier());
            this.unit = "STD_UNIT_CELSIUS_NORMAL_LEFT";
            this.steps = 0.1;
            this.max = 30;
            this.min = 5;
            this.value = this.currentNode.getValue();
            if (!this.value) {
                this.value = 0;
            }
        }
    }
    ngOnDestroy() {
        if (this.buttonSubscription$) {
            this.buttonSubscription$.unsubscribe();
        }
        if (this.countDown) {
            clearTimeout(this.countDown);
        }
        if (this.delayHandle) {
            clearTimeout(this.delayHandle);
            this.delayHandle = undefined;
        }
    }

    _valueIsIcon: boolean = false;

    valueIsIcon() {
        return this._valueIsIcon;
    }

    getValue() {

        if (this.delayed) {
            return '---';
        }
        if (this.type == "countdown") {
            return this.value;
        }
        if (this.type == "numberstring" || this.type == "string") {
            return this.value;
        }
        if (this._sensor instanceof BaseSensor) {
            if (this._sensor.isList()) {
                return this._sensor.getValueAt(this.value);
            }
            if (this._sensor.hasSpecialValue(this.value)) {
                let sv = this._sensor.getSpecialValue(this.value);
                if (this._sensor && this._sensor.hasSpecialValue(this.value)) {
                    let sv = this._sensor.getSpecialValue(this.value);
                    console.log("Value " + this.value + " is special on this sensor.");
                    if (this.hasParameter('showSpecialValueIcons') && sv.hasIcon()) {
                        this._valueIsIcon = true;
                        return sv.getIcon();
                    } else {
                        this._valueIsIcon = false;
                        return this.translator.tr(sv.getReplacement());
                    }
                } else {
                    this._valueIsIcon = false;
                    return this.value;
                }

            } else {
                this.logger.debug("has no special value for " + this.value);
            }
        } else {
            this.logger.debug("has no sensor.");
        }

        if (parseInt(this.steps.toString()) == this.steps) { // ganzzahlig.
            if (this.type == "code" || this.type == "changecode") {
                return Helper.twoDigits(this.value);
            }
            return this.value;
        }
        if (this.steps < 1 && this.steps >= 0.1) {
            return this.value.toFixed(1);
        }
        return this.value.toFixed(2);

    }


    getUnit() {
        if (this._sensor instanceof BaseSensor) {
            if (this._sensor.isList()) {
                return this._sensor.getUnitFor(this.value);
            }
            if (!this._sensor.hasSpecialValue(this.value)) {
                return this.translator.tr(this._sensor.getUnit());
            } else {
                return '';
            }
        }
        return this.translator.tr(this.unit);
    }



    configureStringSetter() {
        this.showMarker = false;
        this.showTexts = false;
        this.unit = "";
        this.value = this.menuService.currentNode.getValue();
        this.showTextInput = true;
        this.title = this.menuService.currentNode.getTitle();

        this.buttonSubscription$ = this.ioService.inputs.events$.subscribe(
            (event) => { this.stringEventHandler(event); }
        );
    }


    timeframeTemperatureSetter() {
        //this.panSkip = 2 ;
        this.title = this.menuService.currentNode.getTitle();
        this.buttonSubscription$ = this.ioService.inputs.events$.subscribe(
            (event) => { this.temperatureForTimeFrameEventHandler(event); }
        );
        this.showMarker = true;
        this.showTexts = true;

        this.showTextInput = false;
        let sensor = this.menuService.currentNode.getOnConfirmTarget();
        if (sensor instanceof BaseSensor) {
            this._sensor = sensor;
        }
        this.value = parseInt(this.currentNode.get('value'));
        this.logger.debug("Temperature Setter: ");
        this.logger.debug(this.value);
        this.unit = "STD_UNIT_CELSIUS_NORMAL_LEFT";
        this.steps = 0.5;
        this.max = 30;
        this.min = 5;
    }



    configureTemperatureSetter() {
        //this.panSkip=3;
        this.title = this.menuService.currentNode.getTitle();
        this.buttonSubscription$ = this.ioService.inputs.events$.subscribe(
            (event) => { this.temperatureEventHandler(event); }
        );
        this.showMarker = true;
        this.showTexts = true;
        this.menuIcon = this.menuService.currentNode.getIcon();
        this.showTextInput = false;

        let sensor = this.menuService.currentNode.getOnConfirmTarget();
        if (sensor instanceof BaseSensor) {
            this.logger.debug("Configuring with sensor: ");
            this.value = sensor.getCurrentValue();
            this.unit = sensor.getUnit();
            this.steps = sensor.getGranularity();
            this.max = sensor.getMaxValue();
            this.min = sensor.getMinValue();
            this.circular = this.currentNode.getTemplateParameters().includes('circular');
            if (this.circular) {
                //console.log("Value is circular: "+JSON.stringify(this.currentNode.getTemplateParameters()));
            } else {
                //console.log("value is not circular."+JSON.stringify(this.currentNode.getTemplateParameters()));
            }

            this._sensor = sensor;
        } else {
            if (this.currentNode.getValue()) {
                this.value = this.currentNode.getValue();
                this.unit = "STD_UNIT_CELSIUS_NORMAL_LEFT";
                this.steps = 0.5;
                this.min = 5;
                this.max = 30;
            }
        }
    }
}
